<!-- 举报列表 -->
<template>
  <div class="report">
    <div class="conent">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="company_name" label="公司名"></el-table-column>
        <el-table-column prop="username" label="公司账户"></el-table-column>
        <el-table-column prop="company_type" label="公司类型"></el-table-column>
        <el-table-column prop="jd_position_name" label="在招职位">
          <template slot-scope="scope">
            <div>{{ scope.row.jd_position_name.third_position_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="jd_place_data" label="职位地点">
          <template slot-scope="scope">
            <div>
              {{ scope.row.jd_place_data.city_name }}-{{
                scope.row.jd_place_data.district_name
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="jd_create_time"
          label="职位创建时间"
        ></el-table-column>
        <el-table-column
          prop="jd_update_time"
          label="职位更新时间"
        ></el-table-column>
        <el-table-column
          prop="agent_company_name"
          label="代理商公司名"
        ></el-table-column>
        <el-table-column
          prop="weixin_nickname"
          label="举报人微信昵称 "
        ></el-table-column>
        <el-table-column
          prop="elite_username"
          label="举报人电话"
        ></el-table-column>
        <el-table-column prop label="举报照片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.img_list.length > 0"
              style="width: 100px; height: 100px"
              :src="scope.row.img_list[0]"
              :preview-src-list="scope.row.img_list"
            ></el-image>
            <div v-else class="kong">暂无</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="report_content"
          label="举报内容"
        ></el-table-column>
        <el-table-column
          prop="report_create_time"
          label="举报时间"
        ></el-table-column>
        <el-table-column prop label="举报类型">
          <template slot-scope="scope">
            <div>{{ report_type[scope.row.report_type] }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="handleClick(scope.row)"
              type="danger"
              size="mini"
              :disabled='scope.row.jd_hide==1'
              >下架</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="15"
          :total="total"
          hide-on-single-page
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      total: 0,
      report_type: {
        r1: "散播违法/敏感言论",
        r2: "人身攻击",
        r3: "色情骚扰",
        r4: "职位虚假",
        r5: "招聘者身份虚假",
        r6: "违法/欺诈行为",
        r7: "收取求职者费用",
        r8: "发布广告和招商信息",
        r9: "其他",
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    pageChange(page) {
      this.init(page - 1);
    },
    init(page) {
      require("post", "/hr24_index_data/v1/report_list/", { page }).then(
        (res) => {
          if (!res.code) {
            this.tableData = res.data.report_data;
            this.total = res.data.report_count;
          }
          console.log(res);
        }
      );
    },
    handleClick(row) {
      console.log(row);
      this.$confirm("是否下架该职位", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        require("post", "/hr24_index_data/v1/out_report_jd/", {
          jd_id: row.jd_id,
          jd_hide: 1,
        }).then((res) => {
          if (!res.code) {
            this.$message({
              type: "info",
              message: "下架成功",
            });
            this.init(0);
          }
          console.log(res);
        });
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init(0);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.report {
  width: calc(100% - 190px);
  min-height: 80vh;
  background: #fff;
  margin-top: 68px;
  margin-left: 190px;
}
.conent {
  width: 90%;
  margin: auto;
  padding: 60px 0;
}
.page {
  padding: 20px 0;
  text-align: center;
}
.kong {
  width: 100px;
  line-height: 100px;
  text-align: center;
  background: #f5f5f5;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/user_management/report.vue